import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { END_POINT } from "config/environment";

export const QUERY_KEY_FOR_NOTIFICATION = "notification";

const getData = async (props: {
  token: string;
}): Promise<any> => {
  const url = `${END_POINT.BASE_URL}/v1/notifications`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };
  const res = await axios.get(url, config);
  const item: any = res.data;
  return item;
};

const NOTIFICATIONS_STALE_MS = 60 * 1000;

export const useGetNotifications = () => {
  const { token } = useGetUserInfo();
  const queryData = useQuery(
    [QUERY_KEY_FOR_NOTIFICATION],
    () =>
      getData({
        token,
      }),
    {
      enabled: !!token,
      staleTime: NOTIFICATIONS_STALE_MS,
      onError: (err: any) => {},
      onSuccess: (data) => {},
    },
  );
  const sortedNotifications = queryData.data?.sort((a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());

  return {
    ...queryData,
    data: sortedNotifications,
  };
};
